import React from 'react'
import { Box, Typography } from '@mui/material'
import { alpha, styled, useTheme } from '@mui/material/styles'
import VerifiedIcon from '@mui/icons-material/Verified'

const BadgeFrame = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: 4,
  padding: '2px 8px',
  borderRadius: '4px',
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
}))

type StandardBadgeProps = {
  label: string
}

/** Marks trading-house content: standard patterns and the alert templates built on them. */
function StandardBadge({ label }: StandardBadgeProps) {
  const theme = useTheme()

  return (
    <BadgeFrame>
      <VerifiedIcon sx={{ fontSize: '0.75rem', color: theme.palette.primary.main }} />
      <Typography
        variant="caption"
        sx={{ fontSize: '0.65rem', fontWeight: 600, color: theme.palette.primary.main }}
      >
        {label}
      </Typography>
    </BadgeFrame>
  )
}

export default StandardBadge
